module.exports = __webpack_public_path__ + "img/E2 Dot Boxes.f115ce1a.png";